import React from 'react';
import DefaultToolTipHeader from './ToolTipComponents/DefaultToolTipHeader';
import DefaultToolTipBody from './ToolTipComponents/DefaultToolTipBody';

import DefaultButtonRow, {
  WorkflowStepActionButtonProps,
} from './ToolTipComponents/DefaultButtonRow';
import { DefaultWorkflowStepToolTipProps } from '../types';

const WorkflowStepToolTip: React.FC<DefaultWorkflowStepToolTipProps> = props => {
  const { completeAndMoveNext, moveNextStep } = props.workflowHook;

  const actionButtonProps: WorkflowStepActionButtonProps = {
    completedText: 'Redo Chapter',
    startedText: 'Complete Chapter',
    startedStateClick: completeAndMoveNext,
    allChildrenCompletedText: 'Complete Chapter',
    allChildrenCompletedStateClick: completeAndMoveNext,
    uncompletedText: 'Start Chapter',
    uncompletedStateClick: moveNextStep,
  };

  return (
    <div>
      <DefaultToolTipHeader workflowHook={props.workflowHook} />
      <DefaultToolTipBody workflowHook={props.workflowHook} />
      <DefaultButtonRow workflowHook={props.workflowHook} actionButtonProps={actionButtonProps} />
    </div>
  );
};

export default React.memo(WorkflowStepToolTip);
